const BIC_REGEX = /^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/

export const isValidBic = (value: string): boolean => {
  if (!value) return false
  const cleaned = value.replace(/\s/g, '').toUpperCase()
  return (cleaned.length === 8 || cleaned.length === 11) && BIC_REGEX.test(cleaned)
}

export const formatBic = (value: string): string => {
  if (!value) return ''
  return value.replace(/\s/g, '').toUpperCase()
}
